import {
  Operations,
  UserGroup,
} from "../../bookmydesk-api-sdk-typescript-axios";

export const kUserGroups: (UserGroup & Operations)[] = [
  {
    id: "963bc239-b639-4a1a-9ef8-000000000006",
    label: "Marketing",
    isEmergencyResponseOfficer: false,
    isDepartment: false,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "39a60e15-7ba0-41df-90d4-5948e3e67cbc",
    label: "Security",
    isEmergencyResponseOfficer: true,
    isDepartment: true,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "963bc239-b639-4a1a-9ef8-5ce117b9f55f",
    label: "Product",
    isEmergencyResponseOfficer: false,
    isDepartment: true,
    releaseHours: 0,
    _operations: {
      canDelete: false,
      cannotDeleteDescription: "Department has linked users or places",
    },
  },
  {
    id: "963bc239-b639-4a1a-9ef8-000000000002",
    label: "Operations",
    isEmergencyResponseOfficer: false,
    isDepartment: false,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "963bc239-b639-4a1a-9ef8-000000000003",
    label: "HR",
    isEmergencyResponseOfficer: false,
    isDepartment: false,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "1b6ce53d-b2dc-4b0e-8c36-3bee35077d54",
    label: "IT",
    isEmergencyResponseOfficer: false,
    isDepartment: true,
    releaseHours: 0,
    _operations: {
      canDelete: false,
      cannotDeleteDescription: "Department has linked users or places",
    },
  },
  {
    id: "3840e937-d989-4c4f-9801-bcc03a09ec3c",
    label: "Legal",
    isEmergencyResponseOfficer: false,
    isDepartment: true,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "963bc239-b639-4a1a-9ef8-000000000004",
    label: "R&D",
    isEmergencyResponseOfficer: false,
    isDepartment: false,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "963bc239-b639-4a1a-9ef8-000000000005",
    label: "Finance",
    isEmergencyResponseOfficer: false,
    isDepartment: false,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "963bc239-b639-4a1a-9ef8-000000000001",
    label: "Sales",
    isEmergencyResponseOfficer: false,
    isDepartment: false,
    releaseHours: 0,
    _operations: {
      canDelete: true,
    },
  },
];
